const MAX_DAYS = 14;

export default class ESigningFormDatepicker {
    /**
     * @description Initialize the signing date picker
     * @returns void
     */
    static init() {
        const signingDateInput = document.getElementById('signingDate');
        if (!signingDateInput) {
            return;
        }

        const $ = window.$;
        if (!$ || !$.fn || !$.fn.datepicker) {
            return;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const minDate = new Date(today);
        minDate.setDate(today.getDate() + 1);

        const maxDate = new Date(today);
        maxDate.setDate(today.getDate() + MAX_DAYS);

        $(signingDateInput).datepicker({
            dateFormat: 'yy-mm-dd',
            firstDay: 1,
            minDate,
            maxDate,
            monthNames: [
                'januari', 'februari', 'mars', 'april', 'maj', 'juni',
                'juli', 'augusti', 'september', 'oktober', 'november', 'december',
            ],
            dayNamesMin: ['sö', 'må', 'ti', 'on', 'to', 'fr', 'lö'],
            onSelect() {
                const selectedDate = $(this).datepicker('getDate');
                const diffDays = Math.round((selectedDate - today) / 86400000);
                const signingDuration = document.getElementById('signingDuration');
                if (signingDuration) {
                    signingDuration.value = diffDays;
                }
            },
            beforeShow() {
                setTimeout(() => { $('.ui-datepicker').css('z-index', 5); }, 0);
            },
        });

        signingDateInput.addEventListener('esigning:setdate', (e) => {
            $(signingDateInput).datepicker('setDate', e.detail.date);
        });
    }
}
